<template>
  <div class="c-eventDetail">
    <PageTitle titleText="イベント予約変更" />
    <div>
      <div
        class="c-eventDetail__card"
        v-for="(preview, index) in previews"
        :key="`preview_${index}`"
      >
        <div class="c-eventDetail__card__title">{{ preview.title }}</div>
        <div class="c-eventDetail__card__title-detail">
          下記日時をご確認の上、ご予定に合わせて以下ご選択をお願いします。
        </div>
        <div
          class="c-eventDetail__card__dateCard"
          v-for="(schedule, sindex) in preview.schedules"
          :key="`schedule_${index}_${sindex}`"
        >
          <div class="c-eventDetail__card__dateCard__title">
            {{ $date(schedule.date).tz().format("YYYY/MM/DD (ddd)") }}
          </div>
          <div class="c-eventDetail__card__dateCard__buttons">
            <div
              class="c-eventDetail__card__dateCard__buttonWrap"
              v-for="(koma, kindex) in schedule.komas"
              :key="`koma_${index}_${sindex}_${kindex}`"
              v-show="!koma.invisible"
            >
              <div
                class="c-eventDetail__card__dateCard__button"
                :class="{
                  disabled:
                    koma.capacity - koma.rooms.length == 0 ||
                    isExcludedRoom(koma),
                }"
                @click="
                  onReserve(
                    preview._id,
                    sindex,
                    kindex,
                    koma.capacity - koma.rooms.length
                  )
                "
              >
                <Button
                  text="欠席"
                  :disabled="koma.capacity - koma.rooms.length == 0"
                  v-if="koma.is_absent"
                ></Button>
                <Button
                  :text="`${koma.start}〜${koma.end}`"
                  :disabled="koma.capacity - koma.rooms.length == 0"
                  v-else
                ></Button>
              </div>
              <div
                v-if="preview.visibleRemaining"
                class="c-eventDetail__card__dateCard__buttonAsideText"
                :style="{ display: isExcludedRoom(koma) ? 'none' : 'block' }"
              >
                残り{{ koma.capacity - koma.rooms.length }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="$router.go(-1)" class="c-eventDetail__returnButtonWrap">
        <el-button>戻る</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewSrevice from "../../../services/preview.service";
import PreviewReserveService from "../../../services/preview-reserve.service";
import PageTitle from "@/components/PageTitle.vue";
import Button from "@/components/Button.vue";
export default {
  components: {
    PageTitle,
    Button,
  },
  data() {
    return {
      isReserved: false,
      previews: [],
      reservedData: {},
      canCancel: true,
    };
  },
  // async created() {
  //   console.log("+created");
  //   await this.reloadData();
  // },
  async mounted() {
    await this.reloadData();
  },
  watch: {
    $route(to, from) {
      console.log("watch", to, from);
      // this.reloadData();
    },
  },
  methods: {
    isExcludedRoom(koma) {
      if (!koma.excludedRooms) {
        return false;
      }
      const exRooms = koma.excludedRooms.split(",");
      return exRooms.includes(this.currentUser.roomNo);
    },
    // schedule.komasがからの場合previewsから削除する
    deleteEmptyKomas(previews) {
      return previews.filter((preview) => {
        preview.schedules = preview.schedules.filter(
          (schedule) => schedule.komas.length > 0
        );
        return preview.schedules.length > 0;
      });
    },
    async reloadData() {
      console.log("reloadData");
      this.isExistReserve();
      const res = await PreviewSrevice.findWithReserve(
        this.$route.params.previewid
      );
      console.log(res.data);
      this.previews = res.data;
      this.previews = this.deleteEmptyKomas(this.previews);
      console.log("this.previews", this.previews);
      var setTitle =
        this.previews[0].title + `予約 | ${this.currentUser.mansion.name}`;
      document.title = setTitle;

      console.log("this.reservedData", this.reservedData);
      // const dl = this.$date(this.reservedData.cancelDeadline).add(1, "days");
      // console.log(dd.format());

      this.canCancel = this.$date().isBefore(this.reservedData.cancelDeadline);
    },
    onUpdate() {
      console.log("onUpdate", this.$route.params);
    },
    async onCancel() {
      if (confirm("予約を取り消しても良いですか？")) {
        console.log("onCancel");

        const res = await PreviewReserveService.remove(this.reservedData._id);
        console.log(res);
        this.$message.success("予約を取り消しました");
        this.reloadData();
      }
    },
    async isExistReserve() {
      const res = await PreviewReserveService.findv2({
        where: {
          mansion: this.currentUser.mansion.id,
          roomNo: this.currentUser.roomNo,
          preview: this.$route.params.previewid,
        },
        option: {
          populate: "preview",
        },
      });
      console.log("res", res);
      this.isReserved = res.data.length > 0;
      if (this.isReserved) {
        this.reservedData = {};
        const previewReserve = res.data[0];
        console.log("previewReserve", previewReserve);
        this.reservedData.cancelDay = previewReserve.preview.cancelDay;
        this.reservedData.cancelDeadline =
          previewReserve.preview.cancelDeadline;
        const preview = res.data[0].preview;
        this.reservedData.title = preview.title;
        this.reservedData.date =
          preview.schedules[previewReserve.scheduleIndex].date;
        this.reservedData.start =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].start;
        this.reservedData.end =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].end;
        this.reservedData._id = previewReserve._id;
      }
    },
    onReserve(previewid, scheduleIndex, komaIndex, nokori) {
      console.log(
        `onReserve_${previewid}_${scheduleIndex},${komaIndex}_${nokori}`
      );
      if (nokori > 0) {
        this.$router.push({
          name: "mc-event-reserve2",
          params: {
            previewid,
            scheduleIndex,
            komaIndex,
            reserveid: this.reservedData._id,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.preview-index {
  font-size: 14px;
}

.koma-parent {
  margin-left: 20px;
}

.koma-item {
  display: flex;
  flex-direction: row;
}
</style>

<style>
.c-eventDetail__card__dateCard__button.disabled {
  pointer-events: none;
}
.c-eventDetail__card__dateCard__button.disabled > .c-button {
  background-color: #f0f0f0;
  color: #b0b0b0;
}
</style>
